<template>
  <div class="playlist">
    <h2>{{ name }} <a href="#" v-on:click="changeName()"><v-icon class="edit" name="edit-3"></v-icon></a></h2>
    <div class="player">
      <vue-plyr :options="playerOptions" :emit="['ended']" @ended="nextSong">
        <audio controls ref="player" >
          <source v-bind:src="currentUrl" type="audio/mp3" />
        </audio>
      </vue-plyr>
    </div>
    <div class="container row">
      <div class="versions col-xs-12 col-sm-4 col-md-4 col-lg-4">
        <div class="actions">
          <b-button v-if="active" v-on:click="toggleArchive()" size="sm" variant="danger">Archive Playlist</b-button>
          <b-button v-if="!active" v-on:click="toggleArchive()" size="sm" variant="success">Unarchive Playlist</b-button>
        </div>
      </div>
      <div v-if="active" class="col-xs-12 col-sm-8 col-md-8 col-lg-8">
        <div class="autoplay">
          <b-form-checkbox
            size="sm"
            id="checkbox-1"
            v-model="autoPlay"
            name="checkbox-1"
            value=true
            unchecked-value=false
          >
            Autoplay next song in list.
          </b-form-checkbox>
        </div>
        <div class="tracklist" >
          <hr />
          <h5>Track List</h5>
          <draggable class="list" v-bind:class="{ show : loaded }" :disabled="!editMode" v-model="listSongs" v-bind="dragOptions" group="people" @start="drag=true" @end="drag=false" :component-data="getComponentData()">
             <div class="item" v-for="(song, idx) in listSongs" :key="song.key" :ref="song.key" v-bind:class="{ active : (currentUrl === song.url) }" >
               <div class="remove" v-if="editMode"><b-badge variant="danger" v-on:click="removeSong(idx)">X</b-badge></div>
               <div class="track">{{ idx + 1}}</div>
               <div class="title" v-on:click="loadFile(song.key, song.url)">{{ song.name }}</div>
               <div class="duration">{{ formatDuration(song.duration) }}</div>
             </div>
          </draggable>
        </div>
        <div class="total-duration">Total duration: {{ formatDuration(totalDuration) }}</div>
        <div>
          <b-button class="edit-button" size="sm" v-on:click="toggleEdit()" :variant="editMode ? 'success': ''">{{ editMode ? 'Done' : 'Edit' }}</b-button>
          <b-dropdown id="dropdown-1" text="Add Song" class="m-md-2" size="sm">
            <b-dropdown-item v-for="(song, idx) in allSongs" :key="idx" href="#" value="" v-on:click="onDropdownClick(song.key)">{{ song.name }}</b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="comments">
          <hr>
          <div v-for="(comment, idx) in Array.from(comments)" class="comment" :key="idx">
            <label>
              <span class="commenter"><img v-bind:src="comment.createdBy.picture" alt="">{{ comment.createdBy.name }} </span>
              <span class="date">{{ new Date(comment.created).toLocaleDateString() }} {{new Date(comment.created).toLocaleTimeString()}} </span>
              <b-badge>{{ comment.version }}</b-badge>
            </label>
            <b-badge v-if="comment.createdBy.name === userData.currentUser.displayName" class="remove" variant="danger" v-on:click="removeComment(comment.created)">X</b-badge>
            {{ comment.comment }}
            <hr>
          </div>
          <label class="commenter"><img v-bind:src="userData.currentUser.photoURL" alt="">{{ userData.currentUser.displayName }}</label>
          <textarea class="comment-input" placeholder="Leave a comment" ref="comment" value=""></textarea>
          <b-button v-on:click="submitComment()">Submit</b-button>
          <p></p>
        </div>
        <div v-if="!active" class="archive-msg col-xs-12 col-sm-8 col-md-8 col-lg-8">
          This playlist is archived. You need to unarchive it to write comments.
        </div>
        </div>
    </div>
  </div>
</template>

<style lang="scss">
.player {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 5px 0;
}

label {
  width: 100%;
  text-align: left;

}
.remove {
  position: absolute;
  right: 15px;
  cursor: pointer;
}

ul {
  padding: 0;
}

.date {
  font-size: 12px;
}
.name {
  font-size: 12px;
}

.upload-btn {
  margin-top: 3px;

  .spinner {
    margin: 2px;
  }
}

.edit {
  width: 20px;
  cursor: pointer;
}
.edit-button {
  margin-right: 2px;
}
#collapse-1 {
  overflow: hidden;
}

.actions {
  margin-top: 15px;
}

.container {
  margin: 0;

  .versions {
    margin: 25px 0;
    text-align: left;

    ul {
      list-style-type: none;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .comments {

    .commenter {
      font-weight: bold;
      padding-top: 2px;
      img {
        width: 24px;
        height: auto;
        margin: -2px 5px 0 0;
        border-radius: 12px;
      }
    }

    .comment {
      text-align: left;
      white-space: pre-line;
    }

    .comment-input {
      width: 100%;
      height: 120px;
      margin-bottom: 10px;
    }
  }
  .tracklist {
    margin-bottom: 15px;

    .list {
      text-align: left;
      opacity: 0;

      &.show {
        opacity: 1;
      }

      .active {
        font-weight: bold;
      }
      .item {
        cursor: pointer;
        position: relative;

        .track {
          position: absolute;
        }
        .title {
          padding-left: 30px;
        }
        .remove {
          position: absolute;
          top: -2px;
          left: -25px;
        }
        .duration {
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }
  }
  .total-duration {
    text-align: right;
  }
}
</style>

<script>
import firebase from 'firebase';
import { auth, db, storage, currentUser } from '../firebaseConfig'
import draggable from 'vuedraggable'
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'playlist',
  // directives: {
  //   dragAndDrop: VueDraggableDirective
  // },
  components: {
      draggable,
  },
  data () {
    const componentInstance = this;
    
    return {
      editMode: false,
      readTimeout: null,
      reloadList: true,
      autoPlay: !isMobile,
      currentKey: '',
      currentUrl: '',
      active: true,
      name: '',
      created: '',
      totalDuration: 0,
      loaded: false,
      comments: [{
        song: '',
        created: '',
        comment: '',
        version: '',
        createdBy: {
          name: '',
          picture: ''
        }
      }],
      listSongs: [],
      allSongs: [],
      file: '',
      userData: {
          currentUser: {
            displayName: '',
            photoURL: ''
          }
      },
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 150,
        ghostClass: "ghost",
        // touchStartThreshold: 4, 
        fallbackTolerance: 4
      };
    },
    playerOptions () {
      const options = {
        invertTime: false,
        controls: [
          'play-large', // The large play button in the center
          'restart', // Restart playback
          // 'rewind', // Rewind by the seek time (default 10 seconds)
          'play', // Play/pause playback
          // 'fast-forward', // Fast forward by the seek time (default 10 seconds)
          'progress', // The progress bar and scrubber for playback and buffering
          'current-time', // The current time of playback
          'duration', // The full duration of the media
          'mute', // Toggle mute
          'volume', // Volume control
          // 'captions', // Toggle captions
          // 'settings', // Settings menu
          // 'pip', // Picture-in-picture (currently Safari only)
          'airplay', // Airplay (currently Safari only)
          'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
          // 'fullscreen' // Toggle fullscreen
        ]
      };
      return options
    },
  },
  mounted() {
    var unwatch = this.$watch('currentUrl', () => {
      this.$refs.player.load()
      unwatch();
    });

    this.$refs.player.addEventListener('ready', event => {
      const player = event.detail.plyr;

      this.$refs.player.addEventListener('loadedmetadata', () => {

        this.saveDuration(this.currentKey, player.duration);
      });
    });

    document.querySelectorAll('[data-plyr="download"]')[0].addEventListener('click', e => {
      e.preventDefault();

      window.open(this.currentUrl, '_blank');

      // this.$http({
      //   method: 'get',
      //   url: this.currentUrl,
      //   responseType: 'arraybuffer',
      //   headers: {
      //     'Access-Control-Allow-Origin'
      //   }
      // })
      // .then(response => {
      //   this.forceFileDownload(response)
      // })
      // .catch(() => console.log('error occured'))

      return null;
    });

    auth.onAuthStateChanged( user => {
      this.$set( this.userData, 'currentUser', user );
    });
    // Get all playlists
    db.collection('playlists').doc(this.$route.params.id).onSnapshot(doc => {
      if (!this.reloadList) return;
      if (doc.exists) {
          this.active = doc.data().active;
          this.name = doc.data().name;
          this.created = doc.data().created;
          this.listSongs = doc.data().songs;
      } else {
          console.log("That playlist doesn't exist!");
      }

      // Get songs
      db.collection('songs').where('active', '==', true).orderBy('lastUpdated', 'desc').get().then(snapshot => {
        // Check if reload should happen
        if (!this.reloadList) return;
        // Reset all songs
        this.allSongs = []
        // Make sure listSongs is created
        if (!this.listSongs) this.listSongs = [];
        // Reset total
        this.totalDuration = 0;
        // Loop through all songs
        snapshot.forEach(song => {
          const i = this.listSongs.indexOf(song.id);
          // Get list songs
          if(i > -1) {
            this.listSongs.splice(i, 1, {
              name: song.data().name,
              url: song.data().files[song.data().files.length -1].url,
              key: song.id,
              duration: song.data().duration ? song.data().duration : 0
            });
            this.totalDuration += song.data().duration;
          } else { // display rest in dropdown
            this.allSongs.push({
              key: song.id,
              name: song.data().name
            })
          }
        });
        this.loaded = true;
        // Can't start an empty list
        if (this.listSongs[0]) {
          this.currentKey = this.listSongs[0].key;
          this.currentUrl = this.listSongs[0].url;
        }


      });
    });
    // Get all comments
    db.collection('comments').where("song", "==", this.$route.params.id)
    .onSnapshot(querySnapshot => {
        this.comments = [];
        querySnapshot.forEach(doc => {
          // console.log(doc.data());
          // this.comments.set(doc.id, doc.data());
          this.comments[this.comments.length] = doc.data();
        });
    })

    // Set comments to read after a timeout
    this.readTimeout = setTimeout(() => {
      // Get a new write batch
      var batch = db.batch();

      for (var i = 0; i < this.comments.length; i++) {
        var ref = db.collection('comments').doc(String(this.comments[i].created));
        var readBy = {};
        readBy[currentUser.uid] = true;
        batch.set(ref, {readBy: readBy}, {merge: true});
      }

      // Commit the batch
      batch.commit();
    }, 2000)
  },
  beforeDestroy() {
    clearTimeout(this.readTimeout);
  },
  created() {

  },
  methods: {
    nextSong() {
      if (this.autoPlay === true) {
        const next = this.listSongs.findIndex(x => x.key === this.currentKey) + 1;
        if (next < this.listSongs.length) this.loadFile(this.listSongs[next].key, this.listSongs[next].url)
      }
    },
    loadFile(key, url) {
      this.currentKey = key;
      this.currentUrl = url;
      this.$refs.player.load()
      this.$refs.player.play()
    },
    submitComment() {
      const timeStamp = new Date().getTime();
      return db.collection('comments').doc(String(timeStamp)).set({
        song: this.$route.params.id,
        created: timeStamp,
        comment: this.$refs.comment.value,
        readBy: {},
        createdBy: {
          name: currentUser.displayName,
          picture: currentUser.photoURL,
          uid: currentUser.uid
        }
      }).then(() => {
        this.$refs.comment.value = '';
        // console.log('comment added');
      })
    },
    saveDuration(id, duration) {
      console.log(id, duration);
      return db.collection('songs').doc(id).update({
        duration: duration
      });
    },
    removeComment(id) {
      db.collection('comments').doc(String(id)).delete().then(function() {
        console.log('Document successfully deleted!');
      }).catch(function(error) {
        console.error('Error removing document: ', error);
      });
    },
    removeSong(index) {
      this.reloadList = false;
      this.totalDuration -= this.listSongs[index].duration;
      // Remove from db
      db.collection('playlists').doc(this.$route.params.id).update({
        songs: firebase.firestore.FieldValue.arrayRemove(this.listSongs[index].key)
      });
      // Put it back in all songs
      this.allSongs.push({
        key: this.listSongs[index].key,
        name: this.listSongs[index].name
      })
      // Remove from list
      this.listSongs.splice(index, 1);
    },
    changeName() {
      var newName = prompt('New name', this.name);

      if (newName !== null && newName !== '') {
        const timeStamp = new Date().getTime();
        this.reloadList = true;
        return db.collection('playlists').doc(this.$route.params.id).update({
          lastUpdated: timeStamp,
          name: newName
        });
      }
    },
    toggleArchive() {
      const msg = this.active ? 'Archive this playlist?' : 'Unarchive this playlist?'
      const archive = confirm(msg)

      if (archive) {
        return db.collection('playlists').doc(this.$route.params.id).update({
          active: !this.active
        });
      }
    },
    onDropdownClick(id) {
      this.reloadList = true;
      return db.collection('playlists').doc(this.$route.params.id).update({
        songs: firebase.firestore.FieldValue.arrayUnion(id)
      });
    },
    onDragEnd(event) {
      // Update the track list
      let keys = [];
      for (var i = 0; i < this.listSongs.length; i++) {
        keys[keys.length] = this.listSongs[i].key;
      }
      // Make sure to not reload list when entering in db
      this.reloadList = false;
      return db.collection('playlists').doc(this.$route.params.id).update({
        songs: keys,
      });
    },
    toggleEdit() {
      this.editMode = !this.editMode;
    },
    formatDuration(duration) {
      const hrs = ~~(duration / 3600);
      const minutes = ~~((duration % 3600) / 60);
      const seconds = ~~duration % 60;

      function str_pad_left(string,pad,length) {
        return (new Array(length+1).join(pad)+string).slice(-length);
      }

      return `${hrs ? `${str_pad_left(hrs, '0', 2)}:`: ``}${str_pad_left(minutes,'0',2)}:${str_pad_left(seconds,'0',2)}`;
    },
    getComponentData() {
      return {
        on: {
          end: this.onDragEnd
        },
        attrs:{
          wrap: true
        },
        props: {
          value: this.activeNames
        }
      };
    }
  }
}
</script>
